import React from 'react';
import { Tooltip } from 'antd';
import { getComplianceNoteDescription } from '../utils/complianceNotes';

type Props = {
  note?: string | null;
  children: React.ReactNode;
  fullWidth?: boolean;
  focusable?: boolean;
  ariaLabel?: string;
};

const ComplianceNoteTooltip = ({
  note,
  children,
  fullWidth = false,
  focusable = false,
  ariaLabel,
}: Props) => {
  const description = getComplianceNoteDescription(note);
  return (
    <Tooltip
      title={description ? `${note?.replace('_', ' ')}: ${description}` : undefined}
      trigger={['hover', 'focus']}
      fresh
      styles={{
        root: { maxWidth: 'min(520px, calc(100vw - 32px))' },
        body: { whiteSpace: 'normal', overflowWrap: 'anywhere' },
      }}
    >
      <span
        aria-label={ariaLabel}
        style={{ display: 'inline-block', width: fullWidth ? '100%' : undefined }}
        tabIndex={focusable && description ? 0 : undefined}
      >
        {children}
      </span>
    </Tooltip>
  );
};

export default ComplianceNoteTooltip;
